/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Day_ThuInputs */

const en_ui_day_thu = /** @type {(inputs: Ui_Day_ThuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu`)
};

const de_ui_day_thu = /** @type {(inputs: Ui_Day_ThuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

/**
* | output |
* | --- |
* | "Thu" |
*
* @param {Ui_Day_ThuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_day_thu = /** @type {((inputs?: Ui_Day_ThuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Day_ThuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_day_thu(inputs)
	return de_ui_day_thu(inputs)
});